import moment from "moment";
import { userService } from "../services";

const FALLBACK_FMS_URL = "http://192.168.60.198:8000/";

const getBaseUrl = () => {
    try {
        const config = JSON.parse(localStorage.getItem("config") || "{}");
        const datas =
            typeof config?.datas === "string" ? JSON.parse(config.datas) : config?.datas;
        const url = datas?.fmsbaseUrl || datas?.fmsBaseUrl;
        if (url) return url.endsWith("/") ? url : `${url}/`;
    } catch (e) {
        console.error("getBaseUrl: could not read fmsbaseUrl from config", e);
    }
    return FALLBACK_FMS_URL;
};

export const FMSReportAction = {
    fetchFmsSummaryReport,
    fetchFmsFuelSummaryReport,
    exportFmsFuelSummaryReport,
    fetchFmsFuelFillReport,
    exportFmsFuelFillReport,
    fetchFmsFuelDroppageReport,
    exportFmsFuelDroppageReport,
    reviewFmsFuelEvent,
    reviewFmsFuelEventsBulk,
};

// ── helpers ──────────────────────────────────────────────────────────────────
// Backend expects dd/MM/yyyy HH:mm. Accepts epoch ms, Date, ISO string,
// or an already formatted "dd/MM/yyyy HH:mm" string.
function toApiDate(val) {
    if (val === null || val === undefined || val === "") return undefined;
    if (typeof val === "string" && /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(val)) return val;
    const m = moment(typeof val === "string" && /^\d+$/.test(val) ? Number(val) : val);
    return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : undefined;
}

// Builds the query string. Arrays are sent as repeated keys
// (vehicleIds=1&vehicleIds=2), which Spring binds to List<Long>/List<String>.
// Builds the query string. Arrays are sent comma separated
// (vehicleIds=1,2,3), which Spring binds to List<Long>/List<String>.
function buildQuery(params) {
    return Object.entries(params)
        .map(([key, value]) => {
            if (value === undefined || value === null || value === "") return null;
            if (Array.isArray(value)) {
                const items = value.filter((v) => v !== undefined && v !== null && v !== "");
                if (items.length === 0) return null;
                return `${key}=${items.map((v) => encodeURIComponent(v.id)).join(",")}`;
            }
            return `${key}=${encodeURIComponent(value)}`;
        })
        .filter(Boolean)
        .join("&");
}

// ── Fuel event report (fill | drop) ──────────────────────────────────────────
// GET fuel-service/api/v1/fuel/fuel-report/{type}
// Accepts the new param names, and also the old ones used by the report pages
// (vehicles, vehicleType, pageNo, pageSize) so existing callers keep working.
async function fetchFmsFuelEventReport(type, {
    fromDate,
    toDate,
    statuses = [],
    vehicleTypeIds,
    transporterIds = [],
    siteIds = [],
    vehicleIds,
    page,
    size,
    // legacy aliases
    vehicles,
    vehicleType,
    pageNo,
    pageSize,
} = {}) {
    try {
        let apiEndPoint = type === "fill" ? "fuel-service/api/v1/fuel/report/" : type == "drop" ? "fuel-service/api/v1/fuel/report/" : "fuel-service/api/v1/fuel/report/dashboard/"
        console.log("sdjfsjdksdjhf", apiEndPoint)
        const query = buildQuery({
            fromDate: toApiDate(fromDate),
            toDate: toApiDate(toDate),
            statuses,
            vehicleTypeIds: vehicleTypeIds ?? vehicleType ?? [],
            transporterIds,
            siteIds,
            vehicleIds: vehicleIds ?? vehicles ?? [],
            page: page ?? pageNo ?? 0,
            size: Math.min(size ?? pageSize ?? 10, 500), // backend @Max(500)
        });

        const apiEndpoint = `${getBaseUrl()}${apiEndPoint}${type}?${query}`;
        const response = await userService.get(apiEndpoint);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log(`fetchFmsFuelEventReport(${type}) error`, error);
        return null;
    }
}

// ── legacy POST helper (summary + exports) ───────────────────────────────────
// ── Fuel summary (aggregate) ─────────────────────────────────────────────────
async function fetchFmsSummaryReport({
    fromDate,
    toDate,
    siteIds = [],
    vehicleTypeIds,
    vehicleIds,
    // legacy aliases
    vehicles,
    vehicleType,
} = {}) {
    try {
        console.log("sdfkljsdlkfsd", vehicleIds)
        const query = buildQuery({
            fromDate: toApiDate(fromDate),
            toDate: toApiDate(toDate),

            vehicleIds: vehicleIds ?? vehicles.map(val => val.id) ?? [],
        });
        const apiEndpoint = `${getBaseUrl()}fuel-service/api/v1/fuel/report/dashboard/vehicle-summary?${query}`;
        const response = await userService.get(apiEndpoint);
        if (response && response.data) return response.data;
        return null;
    } catch (error) {
        console.log("fetchFmsSummaryReport error", error);
        return null;
    }
}

async function exportFmsReport(page, payload, token, type = "excel") {
    try {
        const response = await fetch(
            `${getBaseUrl()}api/v1/exports/reports/page/data?page=${page}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ ...payload, isExcelReport: type === "excel" }),
            },
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.text();
    } catch (error) {
        console.log(`exportFmsReport(${page}) error`, error);
        return null;
    }
}

// ── Fuel Summary (unchanged behaviour) ───────────────────────────────────────
function fetchFmsFuelSummaryReport(params) {
    return fetchFmsFuelEventReport("vehicle-summary", params); // ← put the real path segment here
}
function exportFmsFuelSummaryReport(payload, token, type = "excel") {
    return exportFmsReport("FUELSUMMARY", payload, token, type);
}

// ── Fuel Fill ────────────────────────────────────────────────────────────────
function fetchFmsFuelFillReport(params) {
    return fetchFmsFuelEventReport("fill", params);
}

// TODO: confirm export page key with backend
function exportFmsFuelFillReport(payload, token, type = "excel") {
    return exportFmsReport("FUELFILL", payload, token, type);
}

// ── Fuel Droppage ────────────────────────────────────────────────────────────
function fetchFmsFuelDroppageReport(params) {
    return fetchFmsFuelEventReport("drop", params);
}

// TODO: confirm export page key with backend
function exportFmsFuelDroppageReport(payload, token, type = "excel") {
    return exportFmsReport("FUELDROPPAGE", payload, token, type);
}


// ── Fuel event review ────────────────────────────────────────────────────────
// action: "approve" | "reject" | "reset"
// POST fuel-service/api/v1/fuel/events/{id}/{action}
async function reviewFmsFuelEvent(id, action, remarks = "") {
    try {
        const url = `${getBaseUrl()}fuel-service/api/v1/fuel/events/${id}/${action}`;
        const body = action === "reset" ? {} : { remarks };
        const response = await userService.post(url, body);
        return response?.data ?? null;
    } catch (error) {
        console.log(`reviewFmsFuelEvent(${action}) error`, error);
        return null;
    }
}

// POST fuel-service/api/v1/fuel/events/review
// body: { ids: [..], action: "APPROVE" | "REJECT" | "RESET", remarks }
// Response: { requested, updated, updatedIds, skipped }
async function reviewFmsFuelEventsBulk(ids, action, remarks = "") {
    try {
        const url = `${getBaseUrl()}fuel-service/api/v1/fuel/events/review`;
        const body = { ids, action: action.toUpperCase() };
        if (action !== "reset") body.remarks = remarks;
        const response = await userService.post(url, body);
        return response?.data ?? null;
    } catch (error) {
        console.log(`reviewFmsFuelEventsBulk(${action}) error`, error);
        return null;
    }
}